import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const Workspace = () => {
	return (
		<Accordion disableGutters sx={{ width: '100%' }}>
            <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="workspace-content"
                id="workspace-header"
            >
                <Typography 
                    variant="body1"
                    component="span" 
                    sx={{ color: 'text.primary' }}
                >
					Workspace
				</Typography>
			</AccordionSummary>
			<AccordionDetails sx={{ pt: 0, pb: 1 }}>
				<Typography variant="body2" color="text.secondary">
					Workspace information will be displayed here.
				</Typography>
			</AccordionDetails>
		</Accordion>
	);
};

export default Workspace;
